export default (links, linkedinUrl, pinterestUrl) => {
  const linkedin = { linkedin: linkedinUrl }
  const pinterest = { pinterest: pinterestUrl }

  return { ...links, ...linkedin, ...pinterest }
}
